import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { Grid, Stack, Text, Title } from 'library/ui';
import { HOW_STEPS } from './shared';

export function HowItWorksStep() {
    return (
        <Stack gap="md">
            <Stack gap="sm">
                <Text size="sm" weight="bold" tone="accent">
                    How it Works
                </Text>
                <Title size="h2">Three steps from posting to covered</Title>
            </Stack>
            <Connected>
                <Connector />
                <Grid columns={3} gap="md">
                    {HOW_STEPS.map((step) => (
                        <Stack key={step.n} gap="sm" align="center">
                            <StepNumber>{step.n}</StepNumber>
                            <Text weight="bold">{step.title}</Text>
                            <Text size="sm" tone="secondary" align="center" lineHeight="relaxed">
                                {step.body}
                            </Text>
                        </Stack>
                    ))}
                </Grid>
            </Connected>
        </Stack>
    );
}

const Connected = styled('div')({
    position: 'relative',
    isolation: 'isolate',
});

const Connector = styled('div')({
    position: 'absolute',
    top: 19,
    left: '16.66%',
    right: '16.66%',
    height: 2,
    backgroundColor: Colors.border,
    zIndex: -1,
});

const StepNumber = styled('div')({
    width: 38,
    height: 38,
    borderRadius: '50%',
    backgroundColor: Colors.secondary,
    color: Colors.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: 16,
    border: `3px solid ${Colors.white}`,
    boxShadow: `0 0 0 1px ${Colors.secondaryMuted}`,
    marginBottom: 6,
});
